import GlobalNotifications from "../common/GlobalNotifications";

const HeaderNotices = () => {
  return (
    <div className="sby_notices">
      <GlobalNotifications notifications={window.sby_settings.notifications} />
    </div>
  );
};

export default HeaderNotices;
